import ContentLoader from "react-content-loader";

const PlatformIconSkeleton = (props) => (
  <ContentLoader
    rtl
    speed={10}
    width="100%"
    height="100%"
    viewBox="0 0 50 50"
    backgroundColor="#f6f5f4"
    foregroundColor="#deddda"
    {...props}
  >
    <rect x="0" y="0" rx="0" ry="0" width="100%" height="100%" />
  </ContentLoader>
);

export default PlatformIconSkeleton;
